exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errorRemoveCoupon[data-v-56a7f2c1]{\n    font-size: 12px;\n    color:  #c00;\n}\n.btn-remove-coupon[data-v-56a7f2c1]{\n    border: 0px;\n    background: transparent;\n}\n.removeCoupomIcon[data-v-56a7f2c1]{\n    color: #D0D0D0;\n    font-size: 18px;\n}\n", ""]);

// exports
